import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const textValidationConfig: ValidationConfig = {
  fields: [
    { field: 'text', type: 'string', required: true },
    { field: 'title', type: 'string', required: true }
  ],
  businessRules: [
    {
      name: 'text-content-not-empty',
      validator: (data, layer) => {
        const { encoding } = layer;
        return data.every(item => {
          const text = item[encoding?.text as string];
          return text && typeof text === 'string' && text.trim().length > 0;
        });
      },
      message: 'Text content cannot be empty',
      suggestion: 'Ensure all text fields contain non-empty string values',
      severity: 'error'
    },
    {
      name: 'text-title-not-empty',
      validator: (data, layer) => {
        const { encoding } = layer;
        return data.every(item => {
          const title = item[encoding?.title as string];
          return title && typeof title === 'string' && title.trim().length > 0;
        });
      },
      message: 'Title content cannot be empty',
      suggestion: 'Ensure all title fields contain non-empty string values',
      severity: 'error'
    },
    {
      name: 'text-reasonable-length',
      validator: (data, layer) => {
        const { encoding } = layer;
        return data.every(item => {
          const text = item[encoding?.text as string];
          return !text || typeof text !== 'string' || text.length <= 1000;
        });
      },
      message: 'Text content is very long',
      suggestion: 'Consider limiting text content to 1000 characters for better display',
      severity: 'warning'
    },
    {
      name: 'text-title-reasonable-length',
      validator: (data, layer) => {
        const { encoding } = layer;
        return data.every(item => {
          const title = item[encoding?.title as string];
          return !title || typeof title !== 'string' || title.length <= 100;
        });
      },
      message: 'Title content is very long',
      suggestion: 'Consider limiting title content to 100 characters for better display',
      severity: 'warning'
    },
    {
      name: 'text-sufficient-data',
      validator: data => data.length >= 1,
      message: 'Text layer requires at least one data point',
      suggestion: 'Provide at least one data point with text and title fields',
      severity: 'warning'
    }
  ]
};
